// Format number with commas
export const formatNumber = (num) => {
  return new Intl.NumberFormat('en-US').format(num);
};

// Generate unique ID
export const generateId = () => {
  return Math.random().toString(36).substring(2, 8).toUpperCase();
};

// Get today's date in YYYY-MM-DD format
export const today = () => {
  return new Date().toISOString().split('T')[0];
};

// Calculate warranty expiry
export const calculateWarrantyExpiry = (purchaseDate, warrantyMonths) => {
  if (!purchaseDate || !warrantyMonths) return null;
  const date = new Date(purchaseDate);
  date.setMonth(date.getMonth() + warrantyMonths);
  return date.toISOString().split('T')[0];
};

// Get warranty status
export const getWarrantyStatus = (purchaseDate, warrantyMonths) => {
  if (!purchaseDate || !warrantyMonths) return { status: 'No Warranty', color: 'gray' };
  
  const expiryDate = new Date(calculateWarrantyExpiry(purchaseDate, warrantyMonths));
  const today = new Date();
  const daysLeft = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
  
  if (daysLeft < 0) {
    return { status: 'Expired', color: 'red', days: Math.abs(daysLeft) };
  } else if (daysLeft <= 30) {
    return { status: 'Expiring Soon', color: 'orange', days: daysLeft };
  } else {
    return { status: 'Active', color: 'green', days: daysLeft };
  }
};

// Count serials by status
export const countSerialsByStatus = (serials, status) => {
  return serials?.filter(s => s.status === status).length || 0;
};

// Format date for display
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  });
};

// Format datetime for display
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Categories for products
export const CATEGORIES = [
  'Motherboard', 'Processor', 'RAM', 'Storage', 'Graphics Card',
  'Power Supply', 'Case', 'Monitor', 'Keyboard', 'Mouse',
  'Headset', 'Webcam', 'Other'
];

// Serial statuses
export const SERIAL_STATUSES = [
  'In Stock', 'Sold', 'RMA', 'Loaned', 'Defective', 'Returned',
  'With Supplier (RMA)', 'Replaced by Supplier', 'Credited by Supplier',
  'Allocated to Repair Ticket', 'Reserved for RMA'
];

// RMA statuses (simplified workflow — see PRD Session 22)
export const RMA_STATUSES = [
  'Received',
  'Sent to Supplier',
  'Awaiting Supplier Response',
  'Replaced by Supplier',
  'Credited by Supplier',
  'Rejected by Supplier',
  'Delivered to Customer',
  'Closed',
  'Cancelled'
];

// RMA types
export const RMA_TYPES = ['Customer', 'Internal'];

// PC Build statuses
export const BUILD_STATUSES = ['Building', 'Testing', 'Ready for Delivery', 'Delivered', 'Cancelled'];

// Repair statuses
export const REPAIR_STATUSES = [
  'Pending', 'Received', 'Diagnosing', 'Approved for Supplier RMA', 'Waiting Parts',
  'With Supplier', 'Repaired', 'Completed', 'Collected', 'Cancelled'
];

// Invoice statuses
export const INVOICE_STATUSES = [
  'Draft', 'Ready for Collection', 'Completed'
];

// Payment statuses
export const PAYMENT_STATUSES = [
  'Credit', 'Paid', 'Overdue'
];

// Warranty periods (in months)
export const WARRANTY_PERIODS = [0, 6, 12, 24, 36, 60];

// User roles
export const USER_ROLES = ['staff', 'technician', 'manager', 'admin', 'superadmin'];
